import { getCommunicationChartTeamIdForInternalNode } from '@web/components/CommunicationNetworkGraph/core/communicationChart/constants';
import { CommunicationChartNodeKindEnum } from '@web/components/CommunicationNetworkGraph/core/communicationChart/nodeKind';
import { COMMUNICATION_CHART_CROSS_TEAM_AGGREGATE_NODE_INITIALS, COMMUNICATION_CHART_CROSS_TEAM_SATELLITE_GREY_PALETTE, COMMUNICATION_CHART_DIMMED_PERSON_NODE_PALETTE, COMMUNICATION_CHART_EXTERNAL_NODE_INITIALS, COMMUNICATION_CHART_HUB_SATELLITE_FONT_SIZE_PX, COMMUNICATION_CHART_NODE_STYLE, COMMUNICATION_CHART_ORG_TEAM_NODE_PALETTES, resolveCommunicationChartNodeInitialsFontSizePx } from '@web/components/CommunicationNetworkGraph/graph/communicationChartConstants';
var TWO_PI = Math.PI * 2;
var getFiniteNumber = function (value) {
    var num = Number(value);
    return Number.isFinite(num) ? num : undefined;
};
var resolveCommunicationChartNodeCircleType = function (node) {
    if (node.hasClass('orgTeam') || node.hasClass('teamScopePerson')) {
        var nodeId = getFiniteNumber(node.data('nodeId'));
        if (nodeId !== undefined) {
            return { kind: 'orgTeam', nodeId: nodeId };
        }
    }
    if (node.hasClass(CommunicationChartNodeKindEnum.External) ||
        node.hasClass(CommunicationChartNodeKindEnum.ExternalSpaceChat)) {
        return { kind: 'external' };
    }
    if (node.hasClass(CommunicationChartNodeKindEnum.CrossTeamAggregate)) {
        return { kind: 'crossTeamAggregate' };
    }
    if (node.hasClass(CommunicationChartNodeKindEnum.InternalMeet)) {
        return {
            kind: 'internalMeet',
            hubTeamId: getFiniteNumber(node.data('hubTeamId')),
            nodeId: getFiniteNumber(node.data('nodeId'))
        };
    }
    if (node.hasClass(CommunicationChartNodeKindEnum.CrossTeamSpaceChat)) {
        return { kind: 'crossTeamSpace' };
    }
    if (node.hasClass(CommunicationChartNodeKindEnum.CrossTeam)) {
        return { kind: 'crossTeam' };
    }
    return { kind: 'teamMember' };
};
var resolveNodeTypeCacheKey = function (nodeType) {
    var _a, _b;
    switch (nodeType.kind) {
        case 'orgTeam':
            return "team:".concat(nodeType.nodeId);
        case 'internalMeet':
            return "internalMeet:".concat((_a = nodeType.hubTeamId) !== null && _a !== void 0 ? _a : '', ":").concat((_b = nodeType.nodeId) !== null && _b !== void 0 ? _b : '');
        default:
            return nodeType.kind;
    }
};
var TEAM_PALETTE = {
    main: COMMUNICATION_CHART_NODE_STYLE.teamFill,
    ring: COMMUNICATION_CHART_NODE_STYLE.teamRing,
    dropShadow: COMMUNICATION_CHART_NODE_STYLE.teamDropShadow
};
var toNodeCirclePalette = function (palette, dropShadow) {
    if (dropShadow === void 0) { dropShadow = COMMUNICATION_CHART_NODE_STYLE.teamDropShadow; }
    return ({
        main: palette.main,
        ring: palette.ring,
        dropShadow: dropShadow
    });
};
var ORG_TEAM_PALETTES = COMMUNICATION_CHART_ORG_TEAM_NODE_PALETTES.map(function (palette) {
    return toNodeCirclePalette(palette);
});
var CROSS_TEAM_PALETTE = {
    main: COMMUNICATION_CHART_NODE_STYLE.crossTeamFill,
    ring: COMMUNICATION_CHART_NODE_STYLE.crossTeamRing,
    dropShadow: COMMUNICATION_CHART_NODE_STYLE.teamDropShadow
};
var CROSS_TEAM_SATELLITE_GREY_PALETTE = toNodeCirclePalette(COMMUNICATION_CHART_CROSS_TEAM_SATELLITE_GREY_PALETTE);
var EXTERNAL_PALETTE = {
    main: COMMUNICATION_CHART_NODE_STYLE.externalFill,
    ring: COMMUNICATION_CHART_NODE_STYLE.externalRing,
    dropShadow: null,
    glowDropShadow: COMMUNICATION_CHART_NODE_STYLE.externalGlowDropShadow
};
var DIMMED_PERSON_PALETTE = toNodeCirclePalette(COMMUNICATION_CHART_DIMMED_PERSON_NODE_PALETTE, null);
var defaultNodeVisual = function (palette) { return ({
    fill: palette.main,
    borderColor: COMMUNICATION_CHART_NODE_STYLE.borderColor,
    borderWidth: COMMUNICATION_CHART_NODE_STYLE.borderWidth,
    textColor: COMMUNICATION_CHART_NODE_STYLE.textColor,
    ringColor: palette.ring,
    ringWidth: COMMUNICATION_CHART_NODE_STYLE.ringWidth,
    dropShadow: palette.dropShadow,
    glowDropShadow: palette.glowDropShadow
}); };
var selectedNodeVisual = function (palette) { return ({
    fill: COMMUNICATION_CHART_NODE_STYLE.invertedFill,
    borderColor: palette.main,
    borderWidth: COMMUNICATION_CHART_NODE_STYLE.borderWidth,
    textColor: palette.main,
    ringColor: palette.ring,
    ringWidth: COMMUNICATION_CHART_NODE_STYLE.ringWidth,
    dropShadow: COMMUNICATION_CHART_NODE_STYLE.selectedDropShadow
}); };
var resolveOrgTeamPaletteByNodeId = function (nodeId) {
    return ORG_TEAM_PALETTES[Math.abs(nodeId) % ORG_TEAM_PALETTES.length];
};
var resolveInternalMeetPalette = function (hubTeamId, internalMeetNodeId) {
    if (hubTeamId !== undefined) {
        return resolveOrgTeamPaletteByNodeId(hubTeamId);
    }
    if (internalMeetNodeId !== undefined) {
        var internalTeamId = getCommunicationChartTeamIdForInternalNode(internalMeetNodeId);
        if (internalTeamId !== null) {
            return resolveOrgTeamPaletteByNodeId(internalTeamId);
        }
    }
    return TEAM_PALETTE;
};
var resolvePaletteForNodeType = function (nodeType) {
    switch (nodeType.kind) {
        case 'orgTeam':
            return resolveOrgTeamPaletteByNodeId(nodeType.nodeId);
        case 'external':
            return EXTERNAL_PALETTE;
        case 'crossTeamAggregate':
            return CROSS_TEAM_PALETTE;
        case 'internalMeet':
            return resolveInternalMeetPalette(nodeType.hubTeamId, nodeType.nodeId);
        case 'crossTeamSpace':
            return CROSS_TEAM_SATELLITE_GREY_PALETTE;
        case 'crossTeam':
            return CROSS_TEAM_PALETTE;
        case 'teamMember':
            return TEAM_PALETTE;
    }
};
var resolvePalette = function (node) {
    return resolvePaletteForNodeType(resolveCommunicationChartNodeCircleType(node));
};
var nodeVisualCache = new WeakMap();
var resolveNodeVisualCacheKey = function (node) {
    if (node.hasClass('dimmed')) {
        return 'dimmed';
    }
    var selection = node.hasClass('selectedNode') ? 'selected' : 'default';
    var paletteKey = resolveNodeTypeCacheKey(resolveCommunicationChartNodeCircleType(node));
    return "".concat(selection, "|").concat(paletteKey);
};
export var resolveCommunicationChartNodeVisual = function (node) {
    var cacheKey = resolveNodeVisualCacheKey(node);
    var cached = nodeVisualCache.get(node);
    if ((cached === null || cached === void 0 ? void 0 : cached.cacheKey) === cacheKey) {
        return cached.visual;
    }
    var visual;
    if (node.hasClass('dimmed')) {
        visual = defaultNodeVisual(DIMMED_PERSON_PALETTE);
    }
    else {
        var palette = resolvePalette(node);
        visual = node.hasClass('selectedNode')
            ? selectedNodeVisual(palette)
            : defaultNodeVisual(palette);
    }
    nodeVisualCache.set(node, { cacheKey: cacheKey, visual: visual });
    return visual;
};
var drawShadowCircle = function (ctx, x, y, radius, fill, shadow, opacity) {
    ctx.save();
    ctx.globalAlpha = opacity;
    ctx.shadowColor = shadow.color;
    ctx.shadowBlur = shadow.blur;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = shadow.offsetY;
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, TWO_PI);
    ctx.fillStyle = fill;
    ctx.fill();
    ctx.restore();
};
/** Second stroke: 5px outer ring matching Node card `box-shadow: 0 0 0 5px …`. */
var drawOuterRing = function (ctx, x, y, radius, borderWidth, ringColor, ringWidth, opacity) {
    var ringRadius = radius + borderWidth / 2 + ringWidth / 2;
    ctx.save();
    ctx.globalAlpha = opacity;
    ctx.beginPath();
    ctx.arc(x, y, ringRadius, 0, TWO_PI);
    ctx.strokeStyle = ringColor;
    ctx.lineWidth = ringWidth;
    ctx.stroke();
    ctx.restore();
};
/** First stroke: 2px inner border matching Node card. */
var drawInnerBorder = function (ctx, x, y, radius, borderColor, borderWidth, opacity) {
    ctx.save();
    ctx.globalAlpha = opacity;
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, TWO_PI);
    ctx.strokeStyle = borderColor;
    ctx.lineWidth = borderWidth;
    ctx.stroke();
    ctx.restore();
};
export var drawCommunicationChartNodeLabel = function (ctx, x, y, diameterPx, label, color, opacity, fontSizePx) {
    if (fontSizePx === void 0) { fontSizePx = resolveCommunicationChartNodeInitialsFontSizePx(diameterPx); }
    ctx.save();
    ctx.globalAlpha = opacity;
    ctx.fillStyle = color;
    ctx.font = "600 ".concat(fontSizePx, "px Inter, ui-sans-serif, system-ui, sans-serif");
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(label, x, y);
    ctx.restore();
};
export var drawCommunicationChartNodeCircle = function (_a) {
    var ctx = _a.ctx, x = _a.x, y = _a.y, radius = _a.radius, visual = _a.visual, opacity = _a.opacity, label = _a.label, labelFontSizePx = _a.labelFontSizePx;
    for (var _i = 0, _b = [visual.glowDropShadow, visual.dropShadow]; _i < _b.length; _i++) {
        var shadow = _b[_i];
        if (!shadow) {
            continue;
        }
        drawShadowCircle(ctx, x, y, radius, visual.fill, shadow, opacity);
    }
    drawOuterRing(ctx, x, y, radius, visual.borderWidth, visual.ringColor, visual.ringWidth, opacity);
    ctx.save();
    ctx.globalAlpha = opacity;
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, TWO_PI);
    ctx.fillStyle = visual.fill;
    ctx.fill();
    ctx.strokeStyle = visual.borderColor;
    ctx.lineWidth = visual.borderWidth;
    ctx.stroke();
    ctx.restore();
    if (label) {
        drawCommunicationChartNodeLabel(ctx, x, y, radius * 2, label, visual.textColor, opacity, labelFontSizePx);
    }
};
export var drawCommunicationChartNodeInnerBorder = drawInnerBorder;
export var resolveCommunicationChartNodeLabelFontSizePx = function (node, renderedSize) {
    if (node.hasClass(CommunicationChartNodeKindEnum.InternalMeet) ||
        node.hasClass(CommunicationChartNodeKindEnum.CrossTeamSpaceChat) ||
        node.hasClass(CommunicationChartNodeKindEnum.ExternalSpaceChat)) {
        return COMMUNICATION_CHART_HUB_SATELLITE_FONT_SIZE_PX;
    }
    return resolveCommunicationChartNodeInitialsFontSizePx(renderedSize);
};
export var resolveCommunicationChartCanvasNodeLabel = function (node) {
    if (node.hasClass(CommunicationChartNodeKindEnum.External)) {
        return COMMUNICATION_CHART_EXTERNAL_NODE_INITIALS;
    }
    if (node.hasClass(CommunicationChartNodeKindEnum.CrossTeamAggregate)) {
        return COMMUNICATION_CHART_CROSS_TEAM_AGGREGATE_NODE_INITIALS;
    }
    return undefined;
};
